<template>
    <PageLoader v-if="showLoader" />
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import { useAccountStore } from '~/stores/accountStore';
    import defaultFavicon from '~/assets/images/favicon/favicon.png';
    import PageLoader from '~/components/common/PageLoader.vue';
    import { ref } from 'vue';
    import { useRoute } from 'vue-router';

    const { linkColor, logo } = useAccountStore().state;
    const favicon = logo || defaultFavicon;

    const isLoading = ref(true);
    const route = useRoute();

    const currentLayout = computed(() => route.meta.layout);
    const showLoader = computed(() => isLoading.value && !currentLayout.value);

    const nuxtApp = useNuxtApp();
    nuxtApp.hook('page:finish', () => {
        isLoading.value = false;
    });

    useHead({
        link: [
            { rel: 'icon', type: 'image/x-icon', href: favicon }
        ]
    });
</script>

<style lang="scss">
// set styles for all components - this style tag is not scoped
html, body {
  @apply bg-neutral-100;
}
.lite-sidebar,
.page-description,
.timeline-item,
.page-item {
  a:not(.btn) {
    color: v-bind(linkColor);
    font-weight: 600;
    transition: all 0.15s ease;

    &:not(.pb-image-link):hover {
      filter: brightness(120%);
      text-decoration: underline;
    }
  }
}

.page-icon svg {
  width: 26px;
  max-height: 30px;
}
</style>
